import BlockedAccountErrorModal from '../blocked-account-error-modal/BlockedAccountErrorModal';
import InactiveAccountErrorModal from '../inactive-account-error-modal/InactiveAccountErrorModal';
import AccountNotInBetaErrorModal from '../account_not_in_beta_error_modal/AccountNotInBetaErrorModal';
import ProductUsersBlockedErrorModal from '../product_users_blocked_error_modal/ProductUsersBlockedErrorModal';
import { AccountErrorProps, AccountErrorType } from './types/propTypes';
const AccountError = ({ errorType, onCloseCallback, callLogOut }: AccountErrorProps) => {
  const fetchComponent = () => {
    switch (errorType) {
      case AccountErrorType.LOGIN_BLOCKED:
        return <BlockedAccountErrorModal onCloseCallback={onCloseCallback} callLogOut={callLogOut} />;
      case AccountErrorType.ACCOUNT_INACTIVE_ERROR:
        return <InactiveAccountErrorModal onCloseCallback={onCloseCallback} callLogOut={callLogOut} />;
      case AccountErrorType.ACCOUNT_NOT_IN_BETA:
        return <AccountNotInBetaErrorModal onCloseCallback={onCloseCallback} callLogOut={callLogOut} />;
      case AccountErrorType.PRODUCT_USER_BLOCKED:
        return <ProductUsersBlockedErrorModal onCloseCallback={onCloseCallback} callLogOut={callLogOut} />;
      default:
        return null;
    }
  };
  return <>{fetchComponent()}</>;
};

export default AccountError;
